export const styles = theme => ({
    root: {
        width: "100%",
        justifyContent: "space-between",
        backgroundColor: "#009",
        height: "166px",
        position: "absolute" as const,
        bottom: "0",
    },
    content: {
        margin: "0 auto",
        maxWidth: 1200
    },
    elements: {
        fontSize: "0.875rem",
        letterSpacing: "1px",
        margin: "0 auto",
        color: "white",
        paddingTop: "20px",
        "& ul": {
            listStyleType: "none",
            margin: "10px auto",
        },
        "& li": {
            display: "inline-block",
            margin: "0 10px",
        },
        "& a:hover": {
            textDecoration: "underline",
        },
        "& a": {
            color: "white",
            textDecoration: "none",
        }
    },
    navSocials: {
        margin: "30px 0 30px 10px",
        "& li": {
            listStyle: "none",
            display: "inline-block",
            paddingRight: "18px",

            "& a": {
                color: "white",
            }
        }
    },
});
